define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/locale",
	"csi/reflection",
	"csi/xml",
	"SiteAdmin/Locale"
], function(declare, Controller, locale, reflection, xml, Locale) {

	return declare(Controller, {

		bMarkForDeletion: true,

		preProcess: function() {
			// summary: Do not allow delete custom attribute if it is used in Custom Action
			if (this._isUsedInActions()) {
				this.displayErrorDialog({suffix: "_ErrorUsedInActions"});
			} else {
				this.inherited(arguments);
			}
		},

		toWriter: function() {
			// summary: set MarkedForDeletion attribute to the specified value
			this.inherited(arguments);
			this.m_writer.changeNode(this.m_urlNode).changeAttribute("MarkedForDeletion", xml.ATTR_BOOLEAN, this.bMarkForDeletion);
		},

		postProcessSuccess: function() {
			this.inherited(arguments);
			this.widget.postActionRedrawNode(this);
		},

		_isUsedInActions: function() {
			var nodeCA = this.getNode();
			if (!nodeCA) {
				return false;
			}

			var attrId = Locale.getConfigurableAttributeId(nodeCA);
			var typeClass = Locale.getConfigurableAttributeType(nodeCA);

			var rc = reflection.getClass(typeClass);
			if (!rc) {
				return false;
			}

			var ra = rc.getAttribute(attrId, false, false, true);
			if (!ra) {
				return false;
			}

			return (ra.isPaticipateInAction || ra.hasNotifyLogic);
		}
	});
});
